import PL_utils from '../patterns/pl-utils.js';

export default () => {
  function toggleAccordion(e){
    PL_utils.toggleClass('open', e.target.parentElement.parentElement); // eslint-disable-line no-invalid-this
  }
  document.querySelectorAll('.accordion-title').forEach((element) => {
    element.addEventListener('click', toggleAccordion);
  });
};
